/**
 * セミナー一覧 絞り込み条件 1:無料
 * @deprecated seminarClientListFilterType.tsを使用すること
 * @type {{label: string, value: number}}
 */
export const SEMINAR_LIST_FILTER_TYPE_FREE = {
    label: '無料のセミナー',
    value: 'free',
};
/**
 * セミナー一覧 絞り込み条件 2:オンライン
 * @deprecated seminarClientListFilterType.tsを使用すること
 * @type {{label: string, value: number}}
 */
export const SEMINAR_LIST_FILTER_TYPE_ONLINE = {
    label: 'オンラインのセミナー',
    value: 'online',
};
/**
 * セミナー一覧 絞り込み条件
 * @deprecated seminarClientListFilterType.tsを使用すること
 * @type {{label: string, value: number}[]}
 */
export const SEMINAR_LIST_FILTER_TYPES = [
    SEMINAR_LIST_FILTER_TYPE_FREE,
    SEMINAR_LIST_FILTER_TYPE_ONLINE,
];
